<template>
    <div>
        <Top></Top>
        <div id="wrapper" class="home-page">
            <!-- start header -->
            <div class="headerpage"></div>
            <!-- end header -->
            <section id="banner">
        
            <!-- Slider -->
                <div id="main-slider" class="flexslider">
                    <ul class="slides">
                      <li>
                        <img src="../assets/img/slides/1.jpg" alt="flexslider"/> 
                        <div class="flex-caption">
        <!--                    <p>
                            <h3>株式会社アサテクス へようこそ</h3>
                            </p>
         -->
                        </div> 
                      </li>
                    </ul>
                </div>
            <!-- end slider -->
             </section>
            <section class="jumbobox">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div><h1>業務内容</h1>
                        <hr>
                        </div>
                    </div>
                </div>
            </div>
            </section>
            <section id="content">
                <div class="container business-home">
                    <div class="title"><h2>システムエンジニアリングサービス（SES）</h2></div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="box">
                                <div class="col-md-5">
                                    <img src="../assets/img/ses.jpg" alt="" style="width:680px;height:280px;margin:20px 10px 10px 0;"/>
                                </div>
                                <div class="col-md-6" style="margin:10px 10px 10px 30px">
                                    <p><h3></h3>
                                    <font size=3>　　システムエンジニアリングサービスとはシステム開発のフェーズに応じ、必要な期間だけ、経験豊富なIT人材をアサインすることのできる、常駐型の技術支援サービスです。弊社では、経験豊富なエンジニアから若手まで、年齢層や経験の幅広い、豊富な人材リソースを保持しております。対応可能な技術範囲についても、WEB系・オープン系のエンジニアからインフラ系のエンジニアまで多種多彩な人材がおり、広範にわたりご支援が可能です。十数社に及ぶビジネスパートナーとの提携により、最適な人材をご提案することが可能です。また、チーム体制でのプロジェクト推進についても対応が可能ですので、システム開発業務と連動し、各種管理業務についても実施いたします。</font>
                                    <p><router-link to="/ses" style="float:right">More...</router-link></p></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="title"><h2>ソフトウェア受託開発</h2></div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="box">
                                <div class="col-md-5">
                                    <img src="../assets/img/develop.jpg" alt="" style="width:680px;height:280px;margin:20px 10px 10px 0;"/>
                                </div>
                                <div class="col-md-6" style="margin:10px 10px 10px 30px">
                                    <p><h3></h3>
                                    <font size=3>　　弊社はWEB系、オーブン系などの一括受託開発を受けられます。 オーブンソースを積極的に利用し、品質と納期を確保する上、コスト削減の意識を持って、お客様に安心そして満足できるように受託開発を提供いたします。</font>
                                    <p><router-link to="/dev" style="float:right">More...</router-link></p></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="title"><h2>IT人材育成</h2></div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="box">
                                <div class="col-md-5">
                                    <img src="../assets/img/it_edu.jpg" alt="" style="width:680px;height:280px;margin:20px 10px 10px 0;"/>
                                </div>
                                <div class="col-md-6" style="margin:10px 10px 10px 30px">
                                    <p><h3></h3>
                                    <font size=3>　　豊富な業界ナレッジおよび運用実績に基づいて、IT人材が目指すべきスキルを体系的に定義した上で現状スキル分析・目指す姿とのギャップ分析を実施し、現在の保有スキルを実効性のある育成計画の策定を支援いたします。</font>
                                    <p><a href="#" style="float:right">More...</a></p></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="clients">
                <div class="container">
                    <div class="clients-slider">
                          <div class="title"><h2>開発分野</h2></div>
                          <hr>
                    </div>
        
                    <div class="skills text-center">
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                            <span class="chart" data-percent="70">
                                <span class="percent"></span>
                            </span>
                            <h4 class="title">WEB系</h4>
                        </div>
        
                        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                            <span class="chart" data-percent="20">
                                <span class="percent"></span>
                            </span>
                            <h4 class="title">SalesForce</h4>
                        </div>
        
                        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                            <span class="chart" data-percent="30">
                                <span class="percent"></span>
                            </span>
                            <h4 class="title">スマホアプリ</h4>
                        </div>
                        
                        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                            <span class="chart" data-percent="20">
                                <span class="percent"></span>
                            </span>
                            <h4 class="title">AI人工知能</h4>
                        </div>
        
                    </div>
                    <!-- end skills -->
                </div>
                <!-- end container -->
            </section>
            <section class="jumbobox">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div><h1>経営理念</h1>
                        <hr>
                        </div>
                    </div>
                </div>
            </div>
            </section>
            <section id="content">
                <div class="container business-home">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="box">
                                <div class="col-md-5">
                                    <img src="../assets/img/keiei.jpg" alt="" style="width:650px;height:320px;margin:40px 10px 10px 20px;"/>
                                </div>
                                <div class="col-md-6" style="margin:40px 10px 10px 30px">
                                    <font size=4>目標には夢がある<br>
                       希望がある、輝きがある<br>
                       躍動感がある、充実感がある<br>
                       連帯がある、共生がある<br>
                       忍耐がある、敬愛がある<br>
                       偉大なる人間だから<br>
                       偉大な仕事を
                       成し遂げられるのではない<br>
                       偉大な目標を目指すから<br>
                       人間は偉大になれる<br>
                       自身の無限の可能性を信じて<br>
                       偉大なる目標に挑戦し続ける<br>
                       われわれアサテクスは<br>
                       そういう集団でありたい</font>
                                </div>
                            </div>
                        </div>
                    </div>
        
                </div>
            </section>
            <!-- Gallery Section -->
            <div class="text-center">
            <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div><h1>製品一覧</h1>
                    <hr>
                    </div>
                </div>
            </div>
            <div class="row">
              <div class="portfolio-items">
                <div class="col-sm-6 col-md-4 col-lg-4">
                  <div class="portfolio-item">
                    <div class="hover-bg"> <a href="http://www.asatex.jp/ITTrainNet/" title="eラーニングシステム" data-lightbox-gallery="gallery1" target="_blank">
                      <div class="hover-text">
                        <h4>eラーニングシステム</h4>
                      </div>
                      <img src="../assets/img/portfolio/01-small.jpg" class="img-responsive" alt="eラーニングシステム"> </a> </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-4 col-lg-4">
                  <div class="portfolio-item">
                    <div class="hover-bg"> <a href="#" title="開発中" data-lightbox-gallery="gallery1">
                      <div class="hover-text">
                        <h4>開発中</h4>
                      </div>
                      <img src="../assets/img/portfolio/02-small.jpg" class="img-responsive" alt="開発中"> </a> </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-4 col-lg-4">
                  <div class="portfolio-item">
                    <div class="hover-bg"> <a href="#" title="開発中" data-lightbox-gallery="gallery1">
                      <div class="hover-text">
                        <h4>開発中</h4>
                      </div>
                      <img src="../assets/img/portfolio/03-small.jpg" class="img-responsive" alt="開発中"> </a> </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-4 col-lg-4">
                  <div class="portfolio-item">
                    <div class="hover-bg"> <a href="#" title="開発中" data-lightbox-gallery="gallery1">
                      <div class="hover-text">
                        <h4>開発中</h4>
                      </div>
                      <img src="../assets/img/portfolio/04-small.jpg" class="img-responsive" alt="開発中"> </a> </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-4 col-lg-4">
                  <div class="portfolio-item">
                    <div class="hover-bg"> <a href="#" title="開発中" data-lightbox-gallery="gallery1">
                      <div class="hover-text">
                        <h4>開発中</h4>
                      </div>
                      <img src="../assets/img/portfolio/05-small.jpg" class="img-responsive" alt="開発中"> </a> </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-4 col-lg-4">
                  <div class="portfolio-item">
                    <div class="hover-bg"> <a href="#" title="開発中" data-lightbox-gallery="gallery1">
                      <div class="hover-text">
                        <h4>開発中</h4>
                      </div>
                      <img src="../assets/img/portfolio/06-small.jpg" class="img-responsive" alt="開発中"> </a> </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
            

            
            <section class="aboutUs">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div><h4><a href="news.html" style="color:#FFF">ニュース・お知らせ</a></h4>
                            <table>
                                <tr>
                                    <td style="width:20%"><span>2019/4/26　</span></td>
                                    <td><span class="span-news">ニュース</span></td>
                                    <td><a href="#" style="color:#FFF">株式会社アサテクス (Asatex) 設立</a></td>
                                </tr>
                                <!--
                                <tr>
                                    <td><span>2019/5/9　</span></td>
                                    <td><span class="span-news">ニュース</span></td>
                                    <td><a href="#" style="color:#FFF">令和元年派遣事業開始</a></td>
                                </tr>
                                -->
                            </table>
                        </div>
                        <br/>
                    </div>
                    <!--<div class="col-md-4"><img src="img/img1.png" class="img-center" alt="" /></div>-->
                </div> 
            </div>
            </section>
            <br><br>
            <!-- start footer -->
            <div class="footerpage"></div>
            <!-- end footer -->
        </div>
        <a href="#" class="scrollup"><i class="fa fa-angle-up active"></i></a>
        <Footer></Footer>
    </div>
</template>

<script>
import Top from "@/components/TopMenu.vue"
import Footer from "@/components/Footer.vue"
export default{
    name: 'Home',
    components: {
        Top,
        Footer
    }
}
</script>
<!-- <script src="../assets/js/jquery.js"></script>
<script src="../assets/js/jquery.easing.1.3.js"></script>
<script src="../assets/js/bootstrap.min.js"></script>
<script src="../assets/js/jquery.fancybox.pack.js"></script>
<script src="../assets/js/jquery.fancybox-media.js"></script>
<script src="../assets/js/portfolio/jquery.quicksand.js"></script>
<script src="../assets/js/portfolio/setting.js"></script>
<script src="../assets/js/jquery.flexslider.js"></script>
<script src="../assets/js/animate.js"></script>
<script src="../assets/js/custom.js"></script>
<script src="../assets/js/owl-carousel/owl.carousel.js"></script>
<script src="../assets/js/easypiechart/easypiechart.min.js"></script>
<script src="../assets/js/nivo-lightbox.js"></script>
<script src="../assets/js/main.js"></script> -->
<!-- <script>
    $(document).ready(function(){
        $(".headerpage").load("header.html");
        $(".footerpage").load("footer.html");
    });
</script> -->
<!--
<script>
    // You can also use "$(window).load(function() {"
    $(function () {
      // Slideshow 4
      $("#slider4").responsiveSlides({
        auto: true,
        pager:true,
        nav:true,
        speed: 500,
        namespace: "callbacks",
        before: function () {
          $('.events').append("<li>before event fired.</li>");
        },
        after: function () {
          $('.events').append("<li>after event fired.</li>");
        }
      });

    });
 </script> -->
<!--banner Slider starts Here-->

<style scoped>
</style>